import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Info as InfoIcon } from "@mui/icons-material";
import { GLOBAL_TOOLTIP_PROPS } from "../../config/tooltips.config.ts";

export type AdministrationSectionHeaderProps = {
  title: string;
  /** When set, shows the info icon with this tooltip (matches AI Models Management pattern). */
  infoTooltip?: string;
  /** Optional controls on the right (e.g. Add button), aligned with the title row. */
  actions?: ReactNode;
};

/**
 * Section title row: salmon title + gray info icon, aligned with
 * {@link ManageUseCaseTable} / AI Models Management administration styling.
 */
export function AdministrationSectionHeader({
  title,
  infoTooltip,
  actions,
}: AdministrationSectionHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        flexWrap: "wrap",
        px: { xs: 1, sm: 2 },
        pt: 2,
        pb: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: 400,
            color: "#FF8555",
          }}
        >
          {title}
        </Typography>
        {infoTooltip ? (
          <Tooltip title={infoTooltip} {...GLOBAL_TOOLTIP_PROPS}>
            <IconButton
              size="small"
              aria-label={`About ${title}`}
              sx={{
                color: "#9E9E9E",
                padding: "2px",
                flexShrink: 0,
                "&:hover": { bgcolor: "rgba(0, 0, 0, 0.04)" },
              }}
            >
              <InfoIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </Box>
      {actions != null ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>{actions}</Box>
      ) : null}
    </Box>
  );
}
